import React, { useState } from 'react';
import {
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Chip,
  Box
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import { PaperBorderType, StandardDialog } from '@roc/ui';
import {
  DataGrid as DrawGrid,
  AgGridColumnProps,
  FieldLabel,
  MenuItem,
  Button
} from '@roc/ui';
import { formatCurrency } from '@roc/ui/utils';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { formatDate, LoanProcess } from '@roc/feature-utils';
import {
  AddDrawDocumentDialog,
  useDrawsStore,
  LoanDrawsList,
} from '@roc/feature-draws';
import LoanValuesChart from './components/loanValuesChart';
import LoanContacts from '../common/loanContacts';
import LoanKeyDates from '../common/loanKeyDates';
import { Cancel, MoreVert } from '@material-ui/icons';
import { DRAW_REQUEST_STAGE, DRAW_INIT_STAGE } from '../constants/draws';
import { ConfirmDialog, Paper } from '@roc/ui';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useLoanStore } from '@roc/feature-loans-shared';
import { TodoTaskCard } from '@roc/feature-loan-details';
import { DrawsAccordion } from './components/drawsAccordion';
import { useHistory } from 'react-router';
import { set } from 'date-fns';
import { LoanDrawsPendingTodos } from './components/loanDrawsPendingTodos';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: 24,
  },
  gridContainer: {
    padding: 8,
  },
  drawGridHeader: {
    marginLeft: 25,
    marginRight: 25,
  },
  button: {
    border: `1px solid rgba(40, 83, 145, 1)`,
    borderRadius: 4,
    backgroundColor: 'transparent',
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(40, 83, 145, 1)',
    padding: '4px 8px',
    marginLeft: 10,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: 'rgba(237, 237, 237, 1)'
    }
  },
  link: {
    textDecoration: 'underline',
    color: 'rgba(66, 132, 243, 1)',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    }
  },
  drawDetailsDialog: {
    '& .MuiBox-root': {
      width: '100%',
    },
  }
}));

export const PropertyDrawsDrawsDashboardShared = observer(
  ({ loanId, isCPortal }: { loanId: string, isCPortal?: boolean }) => {
    const {
      drawStore,
      drawStore: { drawList },
    } = useDrawsStore();
    const {
      loanStore: { loanDetails },
    } = useLoanStore();
    const { loanRoutesConfig } = useLoanRoutes();
    const classes = useStyles();
    const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
    const { push } = useHistory();

    useEffect(() => {
      drawStore.fetchDrawsAndRevisions(loanId);
      return () => {
        drawStore.resetDraws();
      };
    }, []);

    const properties = loanDetails?.properties || [];

    return (
      <>
        <Grid container direction="row" spacing={3} xs={12} md={12} style={{
          margin: 0
        }}>
          <Grid item xs={12}>
            <Paper title="Tasks" style={{ paddingBottom: "30px" }}>
              <LoanDrawsPendingTodos loanId={+loanId} properties={properties} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <LoanValuesChart
              chRemaining={
                loanDetails?.calculatedLoanData?.constructionHoldbackRemaining
                  ? loanDetails?.calculatedLoanData?.constructionHoldbackRemaining
                  : 0
              }
              chReimbursedToDate={
                loanDetails?.calculatedLoanData?.constructionHoldbackFunded
                  ? loanDetails?.calculatedLoanData?.constructionHoldbackFunded
                  : 0
              }
              borderType={PaperBorderType.SOLID_BORDER}
            />
          </Grid>
          <Grid style={{ display: 'flex' }} item direction="column" justifyContent='space-between' xs={12} md={6}>
            <LoanContacts />
            <LoanKeyDates
              containerStyle={{
                flex: 1,
                paddingTop: 24,
              }}
              paperStyle={{
                height: '100%'
              }} />
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} className={classes.gridContainer}>
          <Paper className={classes.paper}>
            <Grid container spacing={2}>
              <Grid className={classes.drawGridHeader} container xs={12} md={12} direction='row' justifyContent='space-between'>
                <FieldLabel
                >
                  DRAWS
                </FieldLabel>
                <Box>
                  <Button
                    testId="add-document"
                    variant="contained"
                    className={classes.button}
                    onClick={() => { setIsUploadDialogOpen(true) }
                    }
                  >
                    <AddIcon /> Add document
                  </Button>
                  <Button
                    testId="request-draw"
                    variant="contained"
                    className={classes.button}
                    onClick={() =>
                      push(loanRoutesConfig.loans(loanId).children.drawRequest.url)
                    }
                  >
                    Request Draw
                  </Button>
                  <Button
                    testId="revise-scope-of-work"
                    variant="contained"
                    className={classes.button}
                    onClick={() =>
                      push(loanRoutesConfig.loans(loanId).children.reviseScopeOfWork.url)
                    }
                  >
                    Revise Scope of Work
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <LoanDrawsList loanId={loanId} properties={properties} isCPortal={isCPortal} />
              </Grid>
            </Grid>
          </Paper >
        </Grid >
        <AddDrawDocumentDialog store={drawStore} loanDetails={loanDetails} drawList={drawList} properties={properties} open={isUploadDialogOpen} onClose={setIsUploadDialogOpen} />
      </>
    );
  }
);
